import React from 'react';
export default function MultiPicker(props) {
  var prefixCls = props.prefixCls,
      onValueChange = props.onValueChange,
      onPickerChange = props.onPickerChange,
      children = props.children,
      itemHeight = props.itemHeight,
      selectedValue = props.selectedValue,
      data = props.data;

  function getValue() {
    if (selectedValue && selectedValue.length) {
      return selectedValue;
    }

    if (data) {
      return data.map(function (item) {
        return item && item[0] && item[0].value;
      });
    }

    if (!children) {
      return [];
    }

    return React.Children.map(children, function (child) {
      var childrenArray = React.Children.toArray(child.children || child.props.children);
      return childrenArray && childrenArray[0] && childrenArray[0].props.value;
    });
  }

  function onChange(index, value, callback) {
    var newValue = getValue().concat();
    newValue[index] = value;

    if (callback) {
      callback(newValue, index);
    }
  }

  function _onValueChange(value, index) {
    onChange(index, value, onValueChange);
  }

  function _onScrollChange(value, index) {
    onChange(index, value, onPickerChange);
  }

  function renderChild() {
    var value = getValue();
    return React.Children.map(children, function (col, index) {
      return /*#__PURE__*/React.cloneElement(col, {
        onScrollChange: function onScrollChange(val) {
          return _onScrollChange(val, index);
        },
        onValueChange: function onValueChange(val) {
          return _onValueChange(val, index);
        },
        selectedValue: value[index]
      });
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: prefixCls + "-multi",
    style: {
      lineHeight: itemHeight + "px"
    }
  }, renderChild());
}